<template>
  <Modal
    :modal-style="{ width: '450px' }"
    :title="$t('modals.edit_recipients_modal.title')"
  >
    <DistributedEmailInput
      v-model="localRecipients"
      new-design
    />
    <template #buttons="{ close }">
      <BaseButton
        :label="$t('global.cancel')"
        new-design
        @click="close"
      />
      <BaseButton
        color="primary"
        :label="$t('global.save')"
        new-design
        @click="save(close)"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import DistributedEmailInput from "shared/components/core/forms/DistributedEmailInput.vue";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "EditRecipientsModal",
  components: {
    BaseButton,
    DistributedEmailInput,
    Modal,
  },
  props: {
    recipients: {
      type: Array,
      required: true,
    },
  },
  emits: ["save"],
  data() {
    return {
      localRecipients: [],
    };
  },
  mounted() {
    this.localRecipients = [...this.recipients];
  },
  methods: {
    save(close) {
      this.$emit("save", this.localRecipients);
      close();
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 325px;
}

.media-item-card {
  width: 300px;
  margin: 0 auto;
  box-shadow: none;
}
</style>
